import { Icon } from "@nju/icons";
import { Button, Panel, Separator, Text } from "@nju/ui";

interface IChangeSimEsimDataVerificationWrongDataProps {
  refresh: () => void;
}

export function ChangeSimEsimDataVerificationWrongData({
  refresh,
}: IChangeSimEsimDataVerificationWrongDataProps) {
  return (
    <Panel testId="incorrect-pesel-info-panel">
      <div className="flex flex-col items-center  justify-center">
        <Text
          align="center"
          size={{ "@onlyMobile": "xl", "@fromTablet": "keyM" }}
          weight="bold"
        >
          niepoprawne dane
        </Text>
        <Separator size="m" tone="invisible" />
        <Icon
          className="w-[60px] h-[60px] from-tablet:w-[90px] from-tablet:h-[90px]"
          name="wallet-incircle-fail"
        />
        <Separator size="m" tone="invisible" />
        <Text align="center" size={{ "@onlyMobile": "m", "@fromTablet": "xl" }}>
          Podane przez Ciebie dane nie są poprawne.
        </Text>
        <Separator size="m" tone="invisible" />
        <Button
          onPress={refresh}
          size={{
            "@onlyMobile": "s",
          }}
        >
          spróbuj ponownie
        </Button>
      </div>
    </Panel>
  );
}
